import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { CaptchaField, useCaptcha } from "@/components/Captcha";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

const PASSWORD_RE = /^(?=.*[A-Za-z])(?=.*\d).{10,128}$/;

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ business_name: "", email: "", password: "", invite_code: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const { captcha, setCaptcha, reload, fields } = useCaptcha();

  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (!PASSWORD_RE.test(form.password)) return setErr("Mot de passe : 10 caractères minimum, avec au moins une lettre et un chiffre.");
    setBusy(true);
    try { await register({ ...form, ...fields }); nav("/app"); } catch (e2) { setErr(errMsg(e2)); reload(); } finally { setBusy(false); }
  };

  return (
    <AuthShell title="Créer un compte marchand" subtitle="Inscription sur invitation : un code fourni par l'administrateur est requis." footer={<>Déjà inscrit ? <Link to="/login" className="text-amber-400 hover:underline" data-testid="goto-login-link">Se connecter</Link></>}>
      <form onSubmit={submit} className="space-y-4">
        <div className="space-y-1.5"><Label>Code d'invitation</Label><Input required minLength={4} maxLength={40} autoComplete="off" placeholder="BTC-XXXXXXXX" className="font-mono uppercase" value={form.invite_code} onChange={(e) => setForm({ ...form, invite_code: e.target.value.toUpperCase() })} data-testid="register-invite-input" /></div>
        <div className="space-y-1.5"><Label>Nom de la boutique</Label><Input required minLength={2} maxLength={80} value={form.business_name} onChange={(e) => setForm({ ...form, business_name: e.target.value })} data-testid="register-business-input" /></div>
        <div className="space-y-1.5"><Label>Email</Label><Input type="email" required maxLength={254} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="register-email-input" /></div>
        <div className="space-y-1.5"><Label>Mot de passe (10+ caractères, lettre + chiffre)</Label><Input type="password" required minLength={10} maxLength={128} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="register-password-input" /></div>
        <CaptchaField captcha={captcha} setCaptcha={setCaptcha} reload={reload} prefix="register" />
        {err && <p className="text-sm text-red-400" data-testid="register-error">{err}</p>}
        <Button type="submit" disabled={busy} className="w-full bg-amber-500 hover:bg-amber-400 text-zinc-950 font-semibold" data-testid="register-submit-button">{busy ? "Création…" : "Créer mon compte"}</Button>
      </form>
    </AuthShell>
  );
}
